(function (scope) {
  'use strict';
  const ids = ['mocha','burgundy','sand','camel','mist','mocha-croco','burgundy-croco'];
  const names = ['Mocha Still','Burgundy Still','Sand Still','Camel Still','Mist Still','Mocha Croco','Burgundy Croco'];
  const roles = ['front','angle','back','interior','detail','function','lifestyle','strap','still-life'];
  const text = value => typeof value === 'string' && !/translation missing/i.test(value);
  function url(value) {
    if (typeof value !== 'string' || /[\u0000-\u0020\\]/.test(value)) return false;
    if (/^\/(?!\/)/.test(value)) return true;
    try { return new URL(value.startsWith('//') ? 'https:'+value : value).protocol === 'https:'; } catch { return false; }
  }
  // Native product navigation only: root-relative, optionally locale-prefixed.
  // Reject authorities, queries, fragments, encoded separators and non-product paths.
  function productUrl(value) {
    if (typeof value !== 'string' || /[\u0000-\u0020\u007f\\]/.test(value)) return null;
    const match = value.match(/^\/(?:[a-z]{2,3}(?:-[a-z0-9]{2,8})*\/)?products\/([^/?#]+)\/?$/i);
    if (!match) return null;
    try {
      const handle = decodeURIComponent(match[1]);
      return /^[\p{L}\p{N}][\p{L}\p{N}-]*$/u.test(handle) ? value : null;
    } catch { return null; }
  }
  function normalize(raw, presentation) {
    const diagnostics = [];
    const fail = code => { throw new Error(code); };
    if (!raw || raw.schemaVersion !== 1) fail('INVALID_PAYLOAD');
    if (raw.collectionId !== 'bloom-in-still' || raw.collectionType !== 'showroom_collection') fail('COLLECTION_UNRESOLVED_OR_WRONG');
    if (!Array.isArray(raw.items) || raw.items.length !== 7) fail('EXPECTED_SEVEN_ITEMS');
    const ui = raw.ui;
    for (const k of ['photographAwaited','selectProduct','laptopSize','explore','continueToShop','missingLink','mainShop','productPosition','suedeCollection','viewInShop']) {
      if (!text(ui?.[k]) || !ui[k].trim()) fail('LOCALE_RESOURCE_MISSING');
    }
    for (const role of roles) if (!text(ui.views?.[role]) || !ui.views[role].trim()) fail('ROLE_LOCALE_MISSING');
    const seenProducts = new Set();
    const image = value => value && url(value.src) && text(value.alt) && value.alt.trim()
      ? {src:value.src,alt:value.alt,ready:true,srcset:''} : null;
    const products = raw.items.map((item,i) => {
      if (!item || item.entryType !== 'showroom_item' || item.id !== ids[i] || item.order !== i+1 || item.name !== names[i]) fail('ITEM_IDENTITY_OR_ORDER_INVALID');
      const family = i<5?'suede':'croco';
      if (item.materialFamily !== family) fail('MATERIAL_FAMILY_INVALID');
      const constants = presentation?.[item.id];
      if (!constants || !Number.isFinite(constants.tilt) || !Number.isFinite(constants.offset)) fail('PRESENTATION_CONSTANTS_MISSING');
      const commerce = {};
      for (const size of ['13-14','15-16']) {
        const p = item.products?.[size];
        if (!p || typeof p.id !== 'string' || !/^\d+$/.test(p.id) || !text(p.title) || !p.title.trim()) fail('PRODUCT_REFERENCE_MISSING_OR_INVALID');
        if (seenProducts.has(p.id)) fail('DUPLICATE_PRODUCT_REFERENCE');
        seenProducts.add(p.id);
        const destination = productUrl(p.url);
        if (!destination) diagnostics.push('PRODUCT_LINK_UNAVAILABLE:'+item.id+':'+size);
        commerce[size] = {id:p.id,url:destination,title:p.title,available:typeof p.available==='boolean'?p.available:null};
      }
      const railImage=image(item.railImage);
      if (!railImage) fail('HANGING_IMAGE_REQUIRED');
      const images=[];
      if (!Array.isArray(item.images)) fail('INVALID_IMAGE_PAYLOAD');
      if (new Set(item.images.map(x=>x?.view)).size!==item.images.length || item.images.some(x=>!roles.includes(x?.view))) fail('INVALID_EDITORIAL_ROLES');
      for (const role of roles) {
        const asset=image(item.images.find(x=>x.view===role)?.image);
        if (asset) images.push({view:role,...asset});
        else diagnostics.push('EDITORIAL_ROLE_MISSING:'+item.id+':'+role);
      }
      if(item.detailsPending) diagnostics.push('DETAILS_NORMALIZATION_PENDING:'+item.id);
      const type=raw.productTypes?.[family];
      if (!text(type) || !type.trim()) diagnostics.push('PRODUCT_TYPE_COPY_PENDING:'+family);
      return {id:item.id,name:item.name,order:item.order,materialFamily:family,...constants,
        productType:text(type)?type:'',story:text(item.story)?item.story:null,details:[],
        railImage:{view:'hanging',...railImage},images,
        sizes:[{id:'13-14',label:'13–14″',shopifyUrl:commerce['13-14'].url},{id:'15-16',label:'15–16″',shopifyUrl:commerce['15-16'].url}],
        products:commerce,shopifyUrl:null,shopify:{productId:null,price:null,available:null},motionClip:null};
    });
    // Reached only after every structural validation succeeds. This flag permits
    // product-page links, not cart or checkout operations; each URL is gated too.
    return {config:{shopHome:url(raw.shopHome)?raw.shopHome:null,products,commerceEnabled:true},ui,diagnostics};
  }
  scope.BloomRailProductUrl=productUrl;
  scope.BloomRailNormalize=normalize;
})(typeof window==='undefined'?globalThis:window);
